import {DashboardService} from '../../../../../service/events/dashboard.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseForm} from '../../../../base-form';
import {FincasApiService} from '../../../../../service/api/fincas-api.service';
import {ReactiveDropdownSyncController} from '@fitogest/reactive-form-builder/utils';
import { environment } from '../../../../../../environments/environment';

import { SectorModel } from '../../../../../models/form-common/sector.model';
import { RequestButtonComponent } from '../../../../../common/components/request-button/request-button.component';
import { SectoresFormDefinition } from './form-definition';
import { FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { ReactiveFormStableValueChange } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-sector-form',
    standalone: false,
    templateUrl: './sector-form.component.html',
    styleUrls: ['./sector-form.component.scss']
})
export class SectorFormComponent extends BaseForm<SectorModel> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
        requestButton = new RequestButtonComponent<SectorModel>();

    public form!: SectoresFormDefinition;

    public formRequest = new ReactiveFormRequestCoordinator<SectorModel>;

    override pathToGoBack = 'sectores';

    override model = {} as SectorModel;

    public reactiveFormRecordId = '';


    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public override dashboard: DashboardService,
        public fincasApi: FincasApiService
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi.sectoresPUT,
            fincasApi.sectoresPOST,
            'sectores',
            'Actualizar ' + environment.features.sectorName,
            'Crear ' + environment.features.sectorName
        );

        const routeModel = this.getModel() as unknown as SectorModel;

        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(routeModel);
        this.initializeHostModel(routeModel);
        this.form = new SectoresFormDefinition(
            this.getType(),
            routeModel as unknown as Record<string, string>,
            null,
            {
                fincas: this.fincasApi.fincasGET,
                jardines: this.fincasApi.parcelasGET
            }
        );
    }

    ngOnInit(): void {
        this.resetExternalDropdowns();
        this.initFormData();

        this.formRequest.executePhase(FormPhase.LOAD);

        this.softInit(this.getType());
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<SectorModel>): void {
        const stableValue = this.captureStableValueChange(event.value as SectorModel);

        this.form.model = stableValue;
        this.form.tag = event.changedField;
        this.syncModelFromForm();
    }


    private syncModelFromForm(): void {
        const normalizedModel = { ...(this.form.model as Record<string, unknown>) } as unknown as SectorModel;

        this.form.model = normalizedModel;
        this.updateHostModel(normalizedModel);
    }

    private initFormData(): Promise<boolean> {
        queueMicrotask(() => {
            this.finalizeExternalDropdowns();
            this.refreshReactiveDropdownMappings();
            this.formBuilderRef.updateForm(this.form.model, true);
        });

        return Promise.resolve(true);
    }

    private refreshReactiveDropdownMappings(): void {
        ReactiveDropdownSyncController.refreshMappings({ formBuilder: this.formBuilderRef });
    }
}